export const setFocus = (element) =>
  setTimeout((element) => element.focus(), 0, element)
